module.exports = __webpack_public_path__ + "img/manyPay.697794da.png";